import { render } from "./ModalProdutoIpiranga.vue?vue&type=template&id=54028d44&scoped=true&ts=true"
import script from "./ModalProdutoIpiranga.vue?vue&type=script&lang=ts"
export * from "./ModalProdutoIpiranga.vue?vue&type=script&lang=ts"

import "./ModalProdutoIpiranga.vue?vue&type=style&index=0&id=54028d44&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54028d44"]])

export default __exports__